import React from 'react';
import './form.css';
import { useModal } from '../../../../../context/ModalContext';
import FormWrapper from '../../FormWrapper';

const OwnerRezForm = () => {
    const { modals, closeModal } = useModal();

    return (
        <FormWrapper
            open={modals.ownerRez}
            handleClose={() => closeModal('ownerRez')}
            formId="6c98c242-5272-4a37-8e68-437fd3fe3265"
            heading="Secure Your Spot on the Waitlist!"
            subTitle="Submit the form and be the first to unlock early access to our exciting partner integration—plus, score some exclusive offers along the way!"
            targetId="ownerRezContactForm"
            confirmMessageHeading="🎉 You're in!"
            confirmationMessage={
                <>
                    We're working behind the scenes to bring the awesomeness your way. <br />
                    <br />
                    Keep an eye on your inbox for exciting updates and exclusive offers—big things
                    are coming soon!✨
                </>
            }
        />
    );
};

export default OwnerRezForm;
